import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useEffect, useMemo, useRef, useState } from 'react';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableRow, useMediaQuery, useTheme } from "@mui/material";
import { useFlow } from "../../context/FlowContext";
import { useI18N } from '../../context/I18NContext';
import { useNavigate } from "react-router-dom";
import useWidgetStore from '../../store/useWidgetStore';
import useDataStore from '../../store/useDataStore';
import dayjs from 'dayjs';
import 'dayjs/locale/nl';
import 'dayjs/locale/en';
import DeleteIcon from '@mui/icons-material/Delete';
import { useSettings } from '../../context/SettingsContext';
import { moneyFormat } from '../../helpers/general';
export default function TimeListPicker(props) {
    var _a, _b, _c, _d, _e, _f;
    const [bookableTimes, setBookableTimes] = useState([]);
    const flow = useFlow();
    const theme = useTheme();
    const timeListRef = useRef(null);
    const [enablePicker, setEnablePicker] = useState(true);
    const [hasBookableDate, setHasBookableDate] = useState(true);
    const [enableNext, setEnableNext] = useState(false);
    const [enableAdd, setEnableAdd] = useState(false);
    const [enablePick, setEnablePick] = useState(true);
    const [apptypeStr, setApptypeStr] = useState();
    const [resourceStr, setResourceStr] = useState();
    const [capacityStr, setCapacityStr] = useState();
    const [total, setTotal] = useState(0);
    const [internalTime, setInternalTime] = useState();
    const [tmpInternalTime, setTmpInternalTime] = useState();
    const { t, ts } = useI18N();
    const isLarge = useMediaQuery(theme.breakpoints.up('sm'));
    //const language: string = 'nl' //preference?.language.toString() | 'nl'
    const { language, selectedDate, selectedApptype, selectedResource, selectedCapacity, selectedCapacityGroups, booking, cart, selectedTime, setSelectedTime, setBooking, enabled, setEnabled, setCart } = useWidgetStore();
    const { multipleAppointments, showSelectedResource, staticData } = useSettings();
    const { times, dates, apptypes, resources, products } = useDataStore();
    useEffect(() => {
        var _a, _b, _c, _d;
        setEnablePicker(selectedCapacity > 0 &&
            selectedCapacity >= ((_b = (_a = props.config) === null || _a === void 0 ? void 0 : _a.min) !== null && _b !== void 0 ? _b : 0) &&
            selectedCapacity <= ((_d = (_c = props.config) === null || _c === void 0 ? void 0 : _c.max) !== null && _d !== void 0 ? _d : 100) &&
            hasBookableDate);
    }, [selectedCapacity, selectedApptype, hasBookableDate]);
    useEffect(() => {
        var _a;
        if (multipleAppointments && ((_a = booking === null || booking === void 0 ? void 0 : booking.appointments) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            let appointment = booking.appointments[0];
            let component = appointment.components[0];
            if ((selectedApptype === null || selectedApptype === void 0 ? void 0 : selectedApptype.join(',')) !== component.appointmentTypes.join(',')) {
                // apptype(s) changed, reset all selected date/times
                setBooking({
                    appointments: []
                });
                let _lines = cart.lines;
                _lines = _lines.filter((line) => line.requiredBy !== "appointment" && line.productType !== "subscription");
                setCart(Object.assign(Object.assign({}, cart), { lines: _lines }));
                setTotal(0);
                setEnableAdd(false);
                setEnableNext(false);
                setEnablePick(true);
            }
        }
    }, [selectedApptype]);
    useEffect(() => {
        var _a, _b;
        if (multipleAppointments && ((_a = booking === null || booking === void 0 ? void 0 : booking.appointments) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            let appointment = booking.appointments[0];
            let component = appointment.components[0];
            let _apptypes = [];
            let _resources = [];
            component.resources.forEach((resource_id) => {
                let resource = staticData === null || staticData === void 0 ? void 0 : staticData.resources.find((resource) => {
                    return resource.id === resource_id;
                });
                if (resource) {
                    _resources.push(resource.name);
                }
            });
            component.appointmentTypes.forEach((appointmentType_id, i) => {
                let appointmentType = apptypes.find((appointmentType) => appointmentType.id === appointmentType_id);
                if (appointmentType) {
                    _apptypes.push(appointmentType.name);
                }
            });
            setApptypeStr(_apptypes.join(', '));
            setResourceStr(_resources.join(', '));
            if (selectedCapacity > 1) {
                if (selectedCapacityGroups[0]) {
                    setCapacityStr(ts('%capacity% personen', { capacity: selectedCapacity.toString() }, 'summary'));
                }
                else {
                    let parts = [];
                    const view = flow.views.find((view) => {
                        var _a;
                        const groups = (_a = view === null || view === void 0 ? void 0 : view.components) === null || _a === void 0 ? void 0 : _a.find((component) => {
                            if (component.picker === 'capacity') {
                                return component.config.groups;
                            }
                            return undefined;
                        });
                        return groups === null || groups === void 0 ? void 0 : groups.config.groups;
                    });
                    const groups = (_b = view === null || view === void 0 ? void 0 : view.components) === null || _b === void 0 ? void 0 : _b.find((component) => {
                        if (component.picker === 'capacity') {
                            return component.config.groups;
                        }
                        return undefined;
                    });
                    for (const [_key, _value] of Object.entries(selectedCapacityGroups)) {
                        if (_key !== '0' && _value > 0) {
                            let groupName = groups === null || groups === void 0 ? void 0 : groups.config.groups.find((group) => group.id === parseInt(_key)).name;
                            parts.push(ts('%capacity% %groupName%', { capacity: _value, groupName: t(groupName) }, 'summary'));
                        }
                    }
                    setCapacityStr(parts.join(', '));
                }
            }
            else {
                setCapacityStr('');
            }
            // if (appointment.price > 0) {
            //     setTotalPriceStr(moneyFormat(appointment.price))
            // }
            // else {
            //     setTotalPriceStr('')
            // }
        }
    }, [apptypes, resources, selectedApptype, selectedCapacityGroups, selectedCapacity, selectedTime]);
    useEffect(() => {
        let _bookableTimes = [];
        if (enablePicker) {
            if (selectedDate && selectedDate[0]) {
                let check = dayjs(selectedDate[0]);
                times.forEach((bookable) => {
                    if (dayjs(bookable.time).isSame(check, 'day')) {
                        if (multipleAppointments && (booking === null || booking === void 0 ? void 0 : booking.appointments)) {
                            let selected = booking.appointments.find((appointment) => dayjs(appointment.date).format('YYYY-MM-DD HH:mm') === bookable.time);
                            if (!selected) {
                                _bookableTimes.push(bookable);
                            }
                        }
                        else {
                            _bookableTimes.push(bookable);
                        }
                    }
                });
            }
        }
        setBookableTimes(_bookableTimes);
    }, [times, selectedDate, enablePicker, booking]);
    useEffect(() => {
        if (selectedDate) {
            let activeDate = dayjs(selectedDate[0]), month = activeDate.month(), hasDate = false;
            dates.forEach((bookable) => {
                // note, .month = 0 - 11
                if (dayjs(bookable.time).month() === month) {
                    hasDate = true;
                }
            });
            setHasBookableDate(hasDate);
        }
    }, [dates, selectedDate]);
    const navigate = useNavigate();
    const handleTimePick = (event) => {
        var _a, _b, _c, _d;
        let _timeIndex = event.target.getAttribute('rel').toString(), _time = '', _resource = selectedResource !== null && selectedResource !== void 0 ? selectedResource : [];
        let bookable = bookableTimes[parseInt(_timeIndex.substring(9))];
        if (bookable) {
            _time = bookable.time;
            if (bookable.resource !== '-1') {
                _resource = [parseInt(bookable.resource)];
            }
        }
        setSelectedTime(new Date(_time));
        const component1 = {
            appointmentTypes: selectedApptype !== null && selectedApptype !== void 0 ? selectedApptype : [],
            resources: _resource,
            time: new Date(_time)
        };
        const appointment = {
            date: new Date(_time),
            price: (_a = bookable === null || bookable === void 0 ? void 0 : bookable.price) !== null && _a !== void 0 ? _a : 0,
            components: [
                component1
            ]
        };
        const newBooking = {
            appointments: (_b = booking === null || booking === void 0 ? void 0 : booking.appointments) !== null && _b !== void 0 ? _b : []
        };
        if (multipleAppointments) {
            newBooking.appointments.push(appointment);
        }
        else {
            newBooking.appointments = [appointment];
        }
        setBooking(newBooking);
        if (!enabled.product) {
            setEnabled(Object.assign(Object.assign({}, enabled), { product: true }));
        }
        if ((_c = props.config) === null || _c === void 0 ? void 0 : _c.redirect) {
            navigate(`/oa_widget_${(_d = props.config) === null || _d === void 0 ? void 0 : _d.redirect}`);
            return;
        }
        // setInternalTime(_time)
        setTmpInternalTime(_time);
    };
    const handleDeleteAppointment = (event) => {
        let appointmentIndex = event.target.closest('button').getAttribute('rel').toString();
        let newAppointments = booking.appointments.filter((appointment, index) => index.toString() !== appointmentIndex);
        if (newAppointments.length > 0) {
            const newBooking = {
                appointments: newAppointments
            };
            setBooking(newBooking);
        }
        else {
            setBooking({});
            setEnableNext(false);
            setEnableAdd(false);
            setEnablePick(true);
        }
    };
    useEffect(() => {
        var _a;
        let _lines = cart.lines, _total = 0;
        if (products) {
            // remove any required products by another apptype previously selected
            _lines = _lines.filter((line) => line.requiredBy !== "appointment" && line.productType !== "subscription");
            let requiredProducts = products.filter((product) => product.requiredApp);
            requiredProducts.forEach((product) => {
                let _lineItem = {
                    name: product.name,
                    price: product.price,
                    quantity: 1,
                    productId: product.id,
                    productType: "product",
                    origin: "requiredPurchase",
                    requiredBy: "appointment"
                };
                _lines.push(_lineItem);
                _total += product.price;
            });
            (_a = booking === null || booking === void 0 ? void 0 : booking.appointments) === null || _a === void 0 ? void 0 : _a.forEach((appointment) => {
                _total += appointment.price;
            });
            setTotal(_total);
            setCart(Object.assign(Object.assign({}, cart), { lines: _lines }));
            setInternalTime(tmpInternalTime);
            setTmpInternalTime(undefined);
        }
    }, [products, selectedApptype, tmpInternalTime]);
    useEffect(() => {
        var _a, _b;
        if (multipleAppointments && ((_a = booking === null || booking === void 0 ? void 0 : booking.appointments) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            let appointment = booking.appointments[0];
            let component = appointment.components[0];
            let isSameApptype = (selectedApptype === null || selectedApptype === void 0 ? void 0 : selectedApptype.join(',')) === component.appointmentTypes.join(',');
            setEnableNext(isSameApptype);
            setEnableAdd(isSameApptype);
            setEnablePick(!isSameApptype);
        }
        else {
            setEnableNext(((_b = booking === null || booking === void 0 ? void 0 : booking.appointments) === null || _b === void 0 ? void 0 : _b.length) > 0);
        }
    }, []);
    useEffect(() => {
        var _a;
        if ((booking === null || booking === void 0 ? void 0 : booking.appointments) && ((_a = booking.appointments) === null || _a === void 0 ? void 0 : _a.length) > 0 && selectedTime && internalTime) {
            setInternalTime(undefined);
            if (!multipleAppointments) {
                if (flow.onNext) {
                    flow.onNext();
                }
            }
            else {
                setEnableAdd(true);
                setEnableNext(true);
                setEnablePick(false);
                setTimeout(() => {
                    const element = document.getElementById('time-list-next-btn');
                    if (element) {
                        element.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start',
                            // @ts-ignore
                            container: 'nearest'
                        });
                    }
                }, 200);
            }
        }
    }, [internalTime]);
    const onNext = () => {
        if (flow.onNext) {
            flow.onNext();
        }
    };
    const onAdd = () => {
        setEnablePick(true);
        setEnableAdd(false);
    };
    const moveTo = (newRow, newCol) => {
        const timeList = timeListRef === null || timeListRef === void 0 ? void 0 : timeListRef.current;
        if (timeList) {
            const button = timeList.querySelector(`[aria-rowindex="${newRow}"][aria-colindex="${newCol}"]`);
            if (button) {
                if ((button === null || button === void 0 ? void 0 : button.getAttribute("role")) !== "gridcell") {
                    return false;
                }
                timeList.querySelectorAll("[role=gridcell]").forEach((el) => {
                    el.setAttribute("tabindex", "-1");
                });
                button.setAttribute("tabindex", "0");
                button.focus();
                return true;
            }
        }
    };
    useEffect(() => {
        if (timeListRef.current) {
            timeListRef.current.addEventListener('keydown', (event) => {
                var _a, _b;
                // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/grid_role#keyboard_interactions
                let btn = event.target, maxCols = 4, col = parseInt((_a = btn.ariaColIndex) !== null && _a !== void 0 ? _a : '0'), row = parseInt((_b = btn.ariaRowIndex) !== null && _b !== void 0 ? _b : '0');
                switch (event.key) {
                    case "ArrowRight": {
                        const newRow = col === maxCols ? row + 1 : row;
                        const newCol = col === maxCols ? 0 : col + 1;
                        moveTo(newRow, newCol);
                        break;
                    }
                    case "ArrowLeft": {
                        const newRow = col === 0 ? row - 1 : row;
                        const newCol = col === 0 ? maxCols : col - 1;
                        moveTo(newRow, newCol);
                        break;
                    }
                    case "ArrowDown":
                        moveTo(row + 1, col);
                        break;
                    case "ArrowUp":
                        moveTo(row - 1, col);
                        break;
                    case "Enter": {
                        // console.log(btn.textContent)
                        break;
                    }
                }
            });
        }
    }, [timeListRef]);
    const renderTimes = useMemo(() => {
        return (_jsx(_Fragment, { children: bookableTimes.map((bookable, i) => {
                let col = Math.floor(i % 4), row = (i - col) / 4, label = bookable.label;
                return (_jsx(Box, { sx: {
                        width: isLarge ? '115px' : 'calc(25% - 10px)',
                        marginBottom: '8px',
                        marginLeft: '8px'
                    }, children: _jsx(Button, { disabled: !enablePick && multipleAppointments, "aria-rowindex": row, "aria-colindex": col, "aria-selected": false, role: 'gridcell', sx: {
                            fontSize: '1rem',
                            backgroundColor: theme.palette.primary.main,
                            color: theme.palette.primary.contrastText,
                            borderColor: theme.palette.mode === 'dark'
                                ? theme.palette.primary.light
                                : theme.palette.primary.dark,
                            "&:hover": {
                                color: theme.palette.primary.contrastText,
                                borderColor: theme.palette.primary.contrastText,
                                backgroundColor: theme.palette.mode === 'dark'
                                    ? theme.palette.primary.light
                                    : theme.palette.primary.dark,
                            },
                            "&:focus": {
                                color: theme.palette.primary.contrastText,
                                borderColor: theme.palette.primary.contrastText,
                                backgroundColor: theme.palette.mode === 'dark'
                                    ? theme.palette.primary.light
                                    : theme.palette.primary.dark
                            }
                        }, rel: `bookable-${i}`, onClick: handleTimePick, variant: "outlined", fullWidth: true, children: label }) }, i));
            }) }));
    }, [bookableTimes, selectedDate, enablePick]);
    return (_jsx(_Fragment, { children: _jsx("div", { ref: timeListRef, style: { marginBottom: '1rem' }, children: selectedDate && selectedDate[0] && (_jsxs(_Fragment, { children: [bookableTimes && bookableTimes.length > 0 && (_jsxs(_Fragment, { children: [_jsxs(Typography, { id: "available-times-on", variant: "subtitle1", sx: {
                                    paddingX: 1,
                                    marginY: 1,
                                    fontSize: '1.25rem',
                                    color: theme.palette.text.primary
                                }, children: [t('Beschikbare tijden op'), " ", dayjs((_a = selectedDate[0]) !== null && _a !== void 0 ? _a : new Date()).locale(language).format('dddd D MMMM'), ":"] }), _jsx(Grid, { role: 'grid', container: true, "aria-labelledby": 'available-times-on', sx: {
                                    marginY: 1,
                                    width: '100%'
                                }, children: renderTimes })] })), bookableTimes && bookableTimes.length === 0 && dates && dates.length > 0 && selectedDate.length > 0 && (_jsx(_Fragment, { children: _jsxs(Typography, { variant: "subtitle1", sx: {
                                paddingX: 1,
                                marginY: 1,
                                fontSize: '1.25rem',
                                color: theme.palette.text.primary
                            }, children: [t('Er zijn geen beschikbare tijden op'), " ", dayjs((_b = selectedDate[0]) !== null && _b !== void 0 ? _b : new Date()).locale(language).format('D MMMM')] }) })), multipleAppointments && (_jsxs(_Fragment, { children: [((_c = booking === null || booking === void 0 ? void 0 : booking.appointments) === null || _c === void 0 ? void 0 : _c.length) > 0 && (_jsx(TableContainer, { id: "widget-cart-simple", sx: {
                                    marginBottom: 4,
                                    borderRadius: '0 0 4px 4px',
                                    // overflowX: 'hidden'
                                }, component: Paper, children: _jsx(Table, { size: "small", "aria-label": t('Overzicht van je winkelwagen'), children: _jsxs(TableBody, { sx: {
                                            "& .MuiTableCell-body": {
                                                fontSize: '1rem'
                                            }
                                        }, children: [_jsx(TableRow, { sx: {
                                                    backgroundColor: theme.palette.background.default
                                                }, children: _jsx(TableCell, { colSpan: 3, children: _jsx(Typography, { variant: "h5", sx: {
                                                            fontWeight: 500,
                                                            fontSize: '1.1rem',
                                                            marginTop: 1,
                                                            position: "relative"
                                                        }, children: t("Jouw afspraken") }) }) }, "appointment-line-1"), _jsx(TableRow, { rel: "appointment", 
                                                // onClick={handleRowClick}
                                                sx: {
                                                    backgroundColor: theme.palette.background.default
                                                }, children: _jsxs(TableCell, { colSpan: 3, sx: {
                                                        textOverflow: 'ellipsis',
                                                        overflow: 'hidden'
                                                    }, children: [_jsx(Typography, { gutterBottom: true, variant: "h5", component: "div", sx: { fontSize: '1rem' }, children: apptypeStr }), _jsx(_Fragment, { children: showSelectedResource && resourceStr !== '' && (_jsx(Typography, { variant: "body2", sx: { color: 'text.secondary' }, children: resourceStr })) }), _jsx(_Fragment, { children: capacityStr !== '' && (_jsx(Typography, { variant: "body2", sx: { color: 'text.secondary' }, children: capacityStr })) })] }) }, "appointment-line-2"), _jsx(_Fragment, { children: booking.appointments.map((appointment, i) => (_jsxs(TableRow, { sx: {
                                                        backgroundColor: theme.palette.background.default
                                                    }, children: [_jsx(TableCell, { children: _jsx(Typography, { variant: "h5", sx: { fontSize: '1rem', marginBottom: '0.35em' }, children: dayjs(appointment.date).locale(language).format('dddd D MMMM HH:mm') }, i) }), _jsx(TableCell, { sx: { width: '2em' }, align: "right", children: _jsx(IconButton, { onClick: handleDeleteAppointment, rel: `${i}`, "aria-label": "edit", size: "medium", children: _jsx(DeleteIcon, { sx: { color: theme.palette.text.secondary } }) }) }), _jsx(TableCell, { sx: { width: '4em' }, align: "right", children: moneyFormat(appointment.price) })] }, `appointment-${i}`))) }), _jsx(_Fragment, { children: cart.lines.filter((line) => true).map((line, j) => (_jsxs(TableRow, { sx: {
                                                        backgroundColor: theme.palette.background.default
                                                    }, children: [_jsx(TableCell, { colSpan: 2, children: line.name }), _jsx(TableCell, { sx: { width: '4em' }, align: "right", children: moneyFormat(line.price) })] }, `product-${j}`))) }), _jsxs(TableRow, { sx: {
                                                    backgroundColor: theme.palette.background.default
                                                }, children: [_jsx(TableCell, { colSpan: 2, align: "right", sx: { fontWeight: 500, fontSize: '1.1rem !important' }, children: t('Totaal') }), _jsx(TableCell, { sx: { width: '4em', fontWeight: 500, fontSize: '1.1rem !important' }, align: "right", children: moneyFormat(total) })] }, `total`)] }) }) })), enableAdd && (_jsx(Button, { onClick: onAdd, sx: {
                                    my: 1,
                                    fontSize: '1rem',
                                    width: 'calc(100% - 15px)',
                                    marginLeft: '8px',
                                    "&:hover": {
                                        borderColor: theme.palette.primary.main
                                    }
                                }, variant: "contained", children: t('Nog een afspraak toevoegen', 'select') })), _jsx(Button, { onClick: onNext, disabled: !enableNext, id: "time-list-next-btn", sx: {
                                    my: 1,
                                    fontSize: '1rem',
                                    width: 'calc(100% - 15px)',
                                    marginLeft: '8px',
                                    "&:hover": {
                                        borderColor: theme.palette.primary.main
                                    }
                                }, variant: "contained", children: ((_d = flow.currentRoute) === null || _d === void 0 ? void 0 : _d.actionLabel) ? t(((_f = (_e = flow.currentRoute) === null || _e === void 0 ? void 0 : _e.actionLabel) !== null && _f !== void 0 ? _f : 'Volgende'), 'select') : t('Volgende', 'select') })] }))] })) }) }));
}
